import './polyfills';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/forms.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeClientErrorReporting } from './utils/clientErrorReporting';
import { registerServiceWorker } from './utils/serviceWorkerRegistration';
import { notifyPwaUpdateAvailable } from './components/pwa/PwaUpdateToast';

initializeClientErrorReporting();
registerServiceWorker({ onUpdate: notifyPwaUpdateAvailable });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary label="App">
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
